{/* Auto-generated icon - do not edit */}
import React from 'react'

interface MaleIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const MaleIcon = React.forwardRef<SVGSVGElement, MaleIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 104 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M93.9596 10.8592C85.5185 19.1938 77.1016 27.5049 68.709 35.7927C70.6084 39.4314 72.6844 42.765 74.1566 46.3466C79.3719 59.0284 78.4937 71.5913 72.5407 83.7775C69.5695 89.9379 64.2977 94.6845 57.8611 96.9975C47.9409 100.855 37.0667 101.531 26.745 98.9324C13.7633 95.6507 6.16934 86.8019 2.65727 74.1786C-0.678894 62.1993 0.753959 50.842 7.3718 40.2461C8.24834 38.8073 9.31272 37.492 10.5372 36.3349C16.3699 30.8766 23.5898 27.1251 31.4089 25.4896C38.6762 23.9432 46.2136 24.2253 53.3449 26.3107C56.857 27.2991 60.1832 28.9438 63.2909 30.1718L85.9346 8.25693C85.1693 8.07421 84.3929 7.94064 83.6105 7.85762C81.1414 7.7736 78.6696 7.77039 76.1998 7.7041C72.5374 7.60499 70.9097 6.54775 70.9917 4.3628C71.0712 2.23101 72.6982 1.31134 76.4446 1.2923C77.7921 1.28574 79.1402 1.32118 80.4876 1.2923C85.5355 1.17416 90.5834 1.06186 95.63 0.898436C98.9189 0.790141 100.496 1.78931 101.068 5.05984C101.995 10.3591 102.778 15.6825 103.417 21.0299C103.506 21.6185 103.477 22.2191 103.33 22.796C103.182 23.373 102.921 23.9144 102.561 24.3885C102.201 24.8625 101.749 25.2594 101.233 25.5556C100.716 25.8519 100.146 26.0413 99.5543 26.1129C97.2794 26.3098 95.3537 24.391 95.0866 21.591C95.0761 20.919 95.1063 20.247 95.1771 19.5788C95.21 18.4584 95.2927 17.3334 95.2277 16.2176C95.1299 14.5505 94.9225 12.8899 94.7617 11.2294L93.9596 10.8592ZM34.9826 32.303C31.2736 31.8101 26.3406 33.7751 21.5414 36.3545C16.7293 38.8658 12.8859 42.9023 10.6128 47.8314C5.90161 57.8202 6.94245 67.7281 10.9592 77.5174C14.405 85.9139 20.8116 90.9828 29.7194 92.7845C37.9597 94.4516 46.0489 93.6154 53.9381 90.8994C56.364 90.1289 58.6027 88.8615 60.5115 87.178C62.4202 85.4939 63.9572 83.431 65.0245 81.12C70.9314 68.1744 70.6104 55.4684 62.6788 43.3373C60.6258 40.1974 57.9991 37.5176 54.5336 35.968C48.9351 33.4667 43.0136 32.3161 34.98 32.303H34.9826Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="103.045" height="99.7634" fill={color} transform="translate(0.498047 0.755371)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

MaleIcon.displayName = 'MaleIcon'
